import React, { useState, Fragment, useEffect } from 'react';
import {
    Card,
    CardBody,
    Button, Input,
    Row, Label
} from 'reactstrap';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import Switch from 'rc-switch';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'rc-switch/assets/index.css';
const quillModules = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [
            { list: 'ordered' },
            { list: 'bullet' },
            { indent: '-1' },
            { indent: '+1' },
        ],
        ['link', 'image'],
        ['clean'],
    ],
};

const quillFormats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
];

export default function HelpCenterLocation({ botSettings, saveIntegration }) {
    const [checkedPrimarySmall, setCheckedPrimarySmall] = useState(botSettings.location !== null &&
        !botSettings.location.disabled
    );
    const [locationData, setLocationData] = useState({
        locationLink: "",
        address: ""
    });
    useEffect(() => {
        if (botSettings !== undefined && botSettings.location !== null) {
            setLocationData({
                ...botSettings.location,
                locationLink: botSettings.location.locationLink,
                address: botSettings.location.address
            });
        }
    }, [botSettings]);

    const handleChange = (e) => {
        setLocationData({
            ...locationData,
            locationLink: e.target.value
        });
    }
    const handleChangeAddress = (source, data) => {
        setLocationData({
            ...locationData,
            address: data
        });
    }
    const handleSwitchChange = (value) => {
        setCheckedPrimarySmall(value);
        setLocationData({
            ...locationData,
            disabled: !value
        });
    };
    const handleSave = () => {
        let setting = botSettings;
        setting.location = locationData;
        saveIntegration({
            botSetting: setting
        });
    };
    return (
        <Card className="mb-4">
            <CardBody>
                <div className="text-center">
                    <h6>Location Url</h6>
                </div>
                <Separator className="mb-3" />
                <Row>
                    <Colxx md={12} className='mt-2'>
                        <div className="d-flex w-100">
                            <Label>Enable Location</Label>
                            <Switch
                                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                                checked={checkedPrimarySmall}
                                onChange={(primary) => handleSwitchChange(primary)}
                            />
                        </div>
                    </Colxx>
                    <Colxx md={12} className='mt-2'>
                        <Label>URL</Label>
                        <div className="mb-2">
                            <Input
                                type="textarea"
                                value={locationData.locationLink}
                                onChange={(e) => handleChange(e)}
                                name="locationLink"
                                style={{ height: "100px" }}
                            />
                        </div>
                    </Colxx>
                    {locationData.disabled === true && (
                        <Colxx md={12} className="mt-2">
                            <Label>Address</Label>
                            <ReactQuill
                                theme="snow"
                                value={locationData.address}
                                onChange={(content, delta, source) =>
                                    handleChangeAddress(source, content)
                                }
                                modules={quillModules}
                                formats={quillFormats}
                                name="address"
                            />
                        </Colxx>
                    )}
                    <Colxx md={12} className="mt-2">
                        <div className="mb-1 mt-4 ml-2">
                            <Button
                                color="success"
                                size="xs"
                                className="mt-1"
                                onClick={() => handleSave()}
                            >
                                Save
                            </Button>
                        </div>
                    </Colxx>
                </Row>
            </CardBody>
        </Card>
    );

}